// 手机号校验
export function isMobileNumber(num) {
    let reg = /^[1][0-9]{10}$/;
    return reg.test(num);
}